import { getPermissionKey } from 'src/app/helpers/permission.helper';
import {
  CardDependency,
  ChartFilters,
  ChartTypes,
  DynamicCardType,
  IChartCard,
  IDynamicCard,
  IMapCard,
  IReportsCard,
  IStaticCard,
  ITableCard,
  MapFilters,
  ReportsFilter,
  StaticCardType,
  TableFilters,
} from 'src/app/pages/HomePage/Card/home-card.config';
import { routes } from 'src/configs/permissions.dictionary';

export const STATIC_CARDS: IStaticCard[] = [
  { title: 'homePage.hymotsg', type: StaticCardType.HYMOTS_G_REDIRECTION, content: '' },
  { title: 'homePage.etecube', type: StaticCardType.ETECUBE_REDIRECTION, content: '' },
  {
    title: 'homePage.numberOfEnterprises',
    type: StaticCardType.NUMBER_OF_ENTERPRISES,
    dependency: CardDependency.Enterprises,
    content: '',
    permission: getPermissionKey([routes['/Interests'], 'Enterprise']),
  },
  {
    title: 'homePage.numberOfPersons',
    type: StaticCardType.NUMBER_OF_PERSONS,
    dependency: CardDependency.Persons,
    content: '',
    permission: getPermissionKey([routes['/Interests'], 'Person']),
  },
  {
    title: 'homePage.numberOfVehicles',
    type: StaticCardType.NUMBER_OF_VEHICLES,
    dependency: CardDependency.Vehicles,
    content: '',
    permission: getPermissionKey([routes['/Interests'], 'Vehicle']),
  },
  {
    title: 'homePage.numberOfStudents',
    type: StaticCardType.NUMBER_OF_STUDENTS,
    dependency: CardDependency.Students,
    content: '',
    permission: getPermissionKey([routes['/Students']]),
  },
  {
    title: 'homePage.numberOfArchivedStudents',
    type: StaticCardType.NUMBER_OF_ARCHIVED_STUDENTS,
    dependency: CardDependency.Students,
    content: '',
    permission: getPermissionKey([routes['/Students']]),
  },
  {
    title: 'homePage.numberOfTopics',
    type: StaticCardType.NUMBER_OF_TOPICS,
    dependency: CardDependency.Topics,
    content: '',
    permission: getPermissionKey([routes['/Interests'], 'Topic']),
  },
  {
    title: 'homePage.numberOfTransactions',
    type: StaticCardType.NUMBER_OF_TRANSACTIONS,
    dependency: CardDependency.Transactions,
    content: '',
    permission: getPermissionKey([routes['/Interests'], 'Transaction']),
  },
];

export const DYNAMIC_CARDS: IDynamicCard<any>[] = [
  {
    id: 'a3a41335-1a7b-4353-a51a-d75e83653f53',
    content: '',
    type: DynamicCardType.REPORTS,
    title: 'homePage.reports',
    filterType: ReportsFilter.LIST,
    isDefault: true,
    excludeLayouts: [],
  } as IReportsCard,
  {
    id: '8e739aa1-72e9-43ac-b5ae-743212975a2d ',
    content: '',
    type: DynamicCardType.TABLE,
    title: 'homePage.logs',
    filterType: TableFilters.LOGS,
    isDefault: true,
    excludeLayouts: [],
    minW: 2,
    minH: 2,
    isResizable: false,
    permission: [
      getPermissionKey([routes['/Portal'], 'CustomerAndUser']),
      getPermissionKey([routes['/Portal'], 'UserEvents']),
    ],
  } as ITableCard,
  {
    id: 'be7c282d-62c8-435b-9e85-2ce97928ef03',
    title: 'homePage.enterpriseIndustries',
    chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
    filterType: ChartFilters.ENTERPRISE_INDUSTRIES,
    type: DynamicCardType.CHART,
    content: '',
    dependency: CardDependency.Enterprises,
    isDefault: true,
    excludeLayouts: [],
  } as IChartCard,
  {
    id: '321f5afb-bc00-4a7b-836c-51b4d3016666',
    title: 'homePage.enterpriseCountries',
    type: DynamicCardType.CHART,
    chartTypes: [ChartTypes.LINE, ChartTypes.HISTOGRAM, ChartTypes.SCATTER, ChartTypes.PIE],
    filterType: ChartFilters.ENTERPRISE_COUNTRIES,
    content: '',
    dependency: CardDependency.Enterprises,
    isDefault: true,
    excludeLayouts: [],
  } as IChartCard,
  {
    id: 'f1c2353a-194c-4a5a-a7e6-e0efb09d4bf1',
    title: 'homePage.studentGraduationTimes',
    chartTypes: [ChartTypes.SCATTER, ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.PIE],
    filterType: ChartFilters.STUDENT_GRADUATION_TIME,
    type: DynamicCardType.CHART,
    dependency: CardDependency.Students,
    isDefault: true,
    excludeLayouts: [],
    permission: getPermissionKey([routes['/Students']]),
  } as IChartCard,
  {
    id: '60656f38-7a48-4ede-b431-022fbc51024e',
    title: 'homePage.studentExpectedGraduationTimes',
    chartTypes: [ChartTypes.PIE, ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER],
    filterType: ChartFilters.STUDENT_EXPECTED_GRADUATION_TIME,
    type: DynamicCardType.CHART,
    dependency: CardDependency.Students,
    isDefault: true,
    excludeLayouts: [],
    permission: getPermissionKey([routes['/Students']]),
  } as IChartCard,
  {
    id: 'e5ba3cbb-89fa-46ae-a733-0014b78a939d',
    title: 'homePage.archivedStudentGraduationTimes',
    chartTypes: [ChartTypes.LINE, ChartTypes.HISTOGRAM, ChartTypes.SCATTER, ChartTypes.PIE],
    filterType: ChartFilters.STUDENT_ARCHIVE_GRADUATION_TIME,
    type: DynamicCardType.CHART,
    dependency: CardDependency.Students,
    isDefault: true,
    excludeLayouts: [],
    permission: getPermissionKey([routes['/Students']]),
  } as IChartCard,
  {
    id: '43d90901-4a48-4835-8730-ae2b6f8335c1',
    title: 'homePage.archivedStudentExpectedGraduationTimes',
    chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
    filterType: ChartFilters.STUDENT_ARCHIVE_EXPECTED_GRADUATION_TIME,
    type: DynamicCardType.CHART,
    dependency: CardDependency.Students,
    isDefault: true,
    excludeLayouts: [],
    permission: getPermissionKey([routes['/Students']]),
  } as IChartCard,
  {
    id: '841fcacc-f397-406f-b69b-a24b2de4ac72',
    content: '',
    type: DynamicCardType.MAP,
    title: 'homePage.countries',
    filterType: MapFilters.COUNTRIES,
    isDefault: true,
    excludeLayouts: [],
    minW: 2,
  } as IMapCard,
];

// export const HOME_CARDS: CardType[] = [
//   {
//     id: 'd48ac678-f8ba-457c-ac9d-ac524ea3aff0',
//     title: 'homePage.reports',
//     icon: CardIcons.REPORTS,
//     type: HomeCardType.Redirection,
//     filterType: RedirectionFilters.REPORTS,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     isStatic: true,
//     redirectionType: RedirectionType.REPORTS,
//   },
//   {
//     id: '093a1b72-8421-434d-940a-fb072d61e571',
//     title: 'homePage.hymotsg',
//     icon: CardIcons.HYMOTSG,
//     type: HomeCardType.Redirection,
//     filterType: RedirectionFilters.HYMOTSG,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     isStatic: true,
//     redirectionType: RedirectionType.HYMOTSG,
//   },

//   {
//     id: 'abac82d2-a4db-4fca-b835-f0779a4f1b55',
//     title: 'homePage.etecube',
//     icon: CardIcons.ETECUBE,
//     type: HomeCardType.Redirection,
//     filterType: RedirectionFilters.ETECUBE,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     isStatic: true,
//     redirectionType: RedirectionType.ETECUBE,
//   },

//   {
//     id: '1085d7e3-6841-4c58-8089-035fb9ab5851',
//     title: 'homePage.numberOfEnterprises',
//     icon: CardIcons.ENTERPRISE,

//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_ENTERPRISES,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Enterprises,
//   },
//   // {
//   //   id: "723e7aa6-211e-4f85-bf67-6d709caf528d",
//   //   title: "Number of Countries",
//   //   icon: CardIcons.SUPPLIERS,

//   //   type: HomeCardType.Statistic,
//   //   filterType: StatisticFilters.NUMBER_OF_COUNTRIES,
//   //   value: 0,
//   //   isDefault: true,
//   // },
//   {
//     id: '4fa9f955-5922-4ca3-bc08-3cf197a81f68',
//     title: 'homePage.numberOfPersons',
//     icon: CardIcons.PERSON,

//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_PERSONS,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Persons,
//   },
//   {
//     id: '06f44187-76f0-4ffb-be28-0e2b0343a748',
//     title: 'homePage.numberOfVehicles',
//     icon: CardIcons.VEHICLE,

//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_VEHICLES,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Vehicles,
//   },
//   {
//     id: '613c1462-0bc9-4d32-9500-9751b554fc80',
//     title: 'homePage.numberOfStudents',
//     icon: CardIcons.STUDENT,

//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_STUDENTS,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   {
//     id: '62fb416f-cdf3-4e96-9890-d751f7b57569',
//     title: 'homePage.archiveOfStudents',
//     icon: CardIcons.ARCHIVED_STUDENT,
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.ARCHIVE_OF_STUDENTS,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   {
//     id: 'a1944503-18b9-4844-ae29-7846156038c6',
//     title: 'homePage.numberOfTopics',
//     icon: CardIcons.TOPIC,
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_TOPICS,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Topics,
//   },
//   {
//     id: 'b0f23ebf-8ebb-4826-8c81-476921a041e1',
//     title: 'homePage.numberOfTransactions',
//     icon: CardIcons.TRANSACTION,
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_TRANSACTIONS,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Transactions,
//   },
//   {
//     id: '14ce8062-55e3-40d1-9b9d-b4624abb12c3',
//     title: 'homePage.numberOfSuppliers',
//     icon: CardIcons.SUPPLIERS,

//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_SUPPLIERS,
//     value: 0,
//     tiers: {
//       tier1: {
//         value: 0,
//         navigate: {
//           root: '/Network',
//           state: { activeTab: '1', isHasTierLevel: false },
//         },
//       },
//       tier2: {
//         value: 0,
//         navigate: {
//           root: '/Network',
//           state: { activeTab: '1', isHasTierLevel: true },
//         },
//       },
//     },
//     isDefault: false,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Surfer,
//   },
//   {
//     id: '062e9346-6304-4d79-8554-b20c89e7276f',
//     title: 'homePage.numberOfSourcingCountries',
//     icon: CardIcons.WORLD,
//     navigate: { root: '/Network', state: { activeTab: '5' } },
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.NUMBER_OF_SOURCING_COUNTRIES,
//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: 'b355ed93-ba9e-4df6-8c7a-ee1c58a4c36e',
//     title: 'homePage.myMedia',
//     icon: CardIcons.NEWSPAPER,
//     navigate: { root: '/Network', state: { activeTab: '4' } },
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.MY_MEDIA,

//     value: 0,
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Surfer,
//   },
//   {
//     id: '169e2e5c-ceb1-4e6e-933d-a3fd758fc90d',
//     title: 'homePage.mySuppliersMedia',
//     icon: CardIcons.NEWSPAPER,
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.MY_SUPPLIERS_MEDIA,
//     value: 0,
//     // tiers: [
//     //   { text: "Tier 1", value: 0, navigate: "" },
//     //   { text: "Tier 2 and beyond", value: 0 },
//     // ],
//     tiers: {
//       tier1: { value: 0, navigate: undefined },
//       tier2: { value: 0, navigate: undefined },
//     },
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Surfer,
//   },
//   {
//     id: '08d4e69d-3380-4ee9-b317-112ea8233e0c',
//     title: 'homePage.blacklistedStatus',
//     icon: CardIcons.BLACKLISTED,
//     type: HomeCardType.Statistic,
//     filterType: StatisticFilters.BLACKLISTED_STATUS,

//     value: 'Not Blacklisted',
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: 'f1c2353a-194c-4a5a-a7e6-e0efb09d4bf1',
//     title: 'homePage.studentGraduationTimes',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.STUDENT_GRADUATION_TIME,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   {
//     id: '60656f38-7a48-4ede-b431-022fbc51024e',
//     title: 'homePage.studentExpectedGraduationTimes',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.STUDENT_EXPECTED_GRADUATION_TIME,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   {
//     id: 'e5ba3cbb-89fa-46ae-a733-0014b78a939d',
//     title: 'homePage.archivedStudentGraduationTimes',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.STUDENT_ARCHIVE_GRADUATION_TIME,
//     type: HomeCardType.Chart,
//     isDefault: false,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   {
//     id: '43d90901-4a48-4835-8730-ae2b6f8335c1',
//     title: 'homePage.archivedStudentExpectedGraduationTimes',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.STUDENT_ARCHIVE_EXPECTED_GRADUATION_TIME,
//     type: HomeCardType.Chart,
//     isDefault: false,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//     dependency: CardDependency.Students,
//   },
//   // {
//   //   id: "edde7814-1e0f-4e29-976d-b7a180061404",
//   //   title: "Student - Branches",
//   //   chartTypes: [ChartTypes.PIE],
//   //   filterType: ChartFilters.STUDENT_BRANCHES,
//   //   type: HomeCardType.Chart,
//   //   isDefault: true,
//   //   data: defaultChartData,
//   //   layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//   //   dependency: CardDependency.Surfer,
//   // },
//   // {
//   //   id: "c7f75238-b555-49fb-b2c2-1e468b1f8370",
//   //   title: "Student - Degrees",
//   //   chartTypes: [ChartTypes.PIE],
//   //   filterType: ChartFilters.STUDENT_DEGREES,
//   //   type: HomeCardType.Chart,
//   //   isDefault: true,
//   //   data: defaultChartData,
//   //   layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2],
//   //   dependency: CardDependency.Surfer,
//   // },
//   {
//     id: 'be7c282d-62c8-435b-9e85-2ce97928ef03',
//     title: 'homePage.enterpriseIndustries',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.ENTERPRISE_INDUSTRIES,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Enterprises,
//   },
//   {
//     id: '321f5afb-bc00-4a7b-836c-51b4d3016666',
//     title: 'homePage.enterpriseCountries',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.SCATTER, ChartTypes.LINE, ChartTypes.PIE],
//     filterType: ChartFilters.ENTERPRISE_COUNTRIES,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Enterprises,
//   },
//   {
//     id: 'e6cde5e7-72b8-46e5-a73b-10094feda9f3',
//     title: 'homePage.personAges',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.PERSON_AGES,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Surfer,
//     tooltip: 'This information is provided by Block Network',
//   },
//   {
//     id: '482c7ece-ebfb-4193-91f9-6008ecaf8143',
//     title: 'homePage.personGenders',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.PERSON_GENDERS,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Surfer,
//     tooltip: 'This information is provided by Block Network',
//   },
//   {
//     id: 'a6a4f53c-d3e7-439b-99b9-4aa5eb99f82c',
//     title: 'homePage.vehicleCategories',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.VEHICLE_CATEGORIES,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Surfer,
//     tooltip: 'This information is provided by Block Network',
//   },
//   {
//     id: '4e25eb7d-54aa-4e04-b9bc-163b9e6f8f51',
//     title: 'homePage.vehicleBrands',
//     chartTypes: [ChartTypes.HISTOGRAM, ChartTypes.LINE, ChartTypes.SCATTER, ChartTypes.PIE],
//     filterType: ChartFilters.VEHICLE_BRANDS,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.FULL, LayoutViewType.LAYOUT_2, LayoutViewType.LAYOUT_3],
//     dependency: CardDependency.Surfer,
//     tooltip: 'This information is provided by Block Network',
//   },
//   {
//     id: '9ccff2e4-e0a4-42d9-b8e9-334070a9941e',
//     title: 'homePage.countryRisk',
//     chartTypes: [ChartTypes.PIE],
//     navigate: { root: '/Network', state: { activeTab: '5' } },
//     filterType: ChartFilters.COUNTRY_RISK,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: '9b9ee335-f9f6-47a0-af0b-eda8eaa88971',
//     title: 'homePage.industryRisk',
//     navigate: { root: '/Network', state: { activeTab: '6' } },

//     chartTypes: [ChartTypes.PIE],
//     filterType: ChartFilters.INDUSTRY_RISK,
//     type: HomeCardType.Chart,
//     data: defaultChartData,
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: '83be8bac-d5b0-4ddb-8137-b83ad775d78a',
//     title: 'homePage.vulnerabilityToModernSlavery',
//     navigate: { root: '/Network', state: { activeTab: '5' } },

//     chartTypes: [ChartTypes.PIE],
//     filterType: ChartFilters.VULNERABILITRY_TO_MODERN_SLAVERY,
//     type: HomeCardType.Chart,
//     data: defaultChartData,
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: '956b0a02-a5e6-4e52-b201-9d14ea9d116b',
//     title: 'homePage.prevalenceIndexRank',
//     navigate: { root: '/Network', state: { activeTab: '5' } },

//     chartTypes: [ChartTypes.PIE],
//     filterType: ChartFilters.PREVALENCE_INDEX_RANK,
//     type: HomeCardType.Chart,
//     isDefault: true,
//     data: defaultChartData,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: '1d7b544b-9097-4a16-be9f-439e07fddb18',
//     title: 'homePage.governmentResponseRating',
//     navigate: { root: '/Network', state: { activeTab: '5' } },

//     chartTypes: [ChartTypes.PIE, ChartTypes.HISTOGRAM],
//     filterType: ChartFilters.GOVERNMENT_RESPONSE_RATING,
//     type: HomeCardType.Chart,
//     data: defaultChartData,
//     isDefault: true,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
//   {
//     id: '6715a260-6848-4d1c-b347-f125d5f8048d',
//     title: 'homePage.tipTier',
//     navigate: { root: '/Network', state: { activeTab: '5' } },

//     chartTypes: [ChartTypes.PIE],
//     filterType: ChartFilters.TIP_TIER,
//     type: HomeCardType.Chart,
//     isDefault: true,

//     data: defaultChartData,
//     layoutModes: [LayoutViewType.LAYOUT_1],
//     dependency: CardDependency.Suppliers,
//   },
// ];
